import type { FC } from "react";
import React from "react";

import { ButtonCellActionDefaultPreset } from "../../helpers/ButtonCellActionDefaultPreset";

import type { ButtonCellActionPresetProps } from "../../types";

export const ButtonCellActionCopyLink: FC<ButtonCellActionPresetProps> = (
    props,
) => {
    return (
        <ButtonCellActionDefaultPreset
            {...props}
            view="secondary"
            icon="glyph_url_24+"
        />
    );
};

ButtonCellActionCopyLink.displayName = "ButtonCellActionCopyLink";
